// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__34vxP","header":"PatientBlock_header__11dE0","label":"PatientBlock_label__1GFTd","option":"PatientBlock_option__ytC0w"};